module.exports = __webpack_public_path__ + "static/media/expertnetwork-logo.855749f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/expertnetwork-logo.png
// module id = 484
// module chunks = 0